import { REVIEWS_V2_LISTCARDS_V2_FLAG } from '@/constants/experimentConstants';
import { useConfidenceFlag } from '@/hooks/useConfidenceFlag';
import { createContext, ReactNode, useContext } from 'react';

const ListCardsV2Context = createContext<boolean | null>(null);

/**
 * Resolves the flag once for a page so every list card reads the same value — per-card
 * resolution meant one Confidence lookup per card and cards flipping Legacy → V2 one by one.
 */
export const ListCardsV2Provider = ({ children }: { children: ReactNode }) => {
  const { flagValue } = useConfidenceFlag(REVIEWS_V2_LISTCARDS_V2_FLAG.name, REVIEWS_V2_LISTCARDS_V2_FLAG.defaultValue);
  return (
    <ListCardsV2Context.Provider value={Boolean(flagValue?.['listcards-v2'])}>{children}</ListCardsV2Context.Provider>
  );
};

/** Off renders the Legacy* service/employee list cards and their read-more flows. */
export const useListCardsV2 = (): boolean => {
  const provided = useContext(ListCardsV2Context);
  // Outside a provider, resolve it here so a card rendered elsewhere still works.
  const { flagValue } = useConfidenceFlag(
    REVIEWS_V2_LISTCARDS_V2_FLAG.name,
    REVIEWS_V2_LISTCARDS_V2_FLAG.defaultValue,
    provided === null,
  );
  return provided ?? Boolean(flagValue?.['listcards-v2']);
};
